import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  Router,
  RouterStateSnapshot,
  Routes,
} from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { inject } from '@angular/core';
import { HomepageComponent } from './pages/homepage/homepage.component';
import { ErrorPageComponent } from './core/components/error-page/error-page.component';
import { AppService } from './service/app.service';
import { UnauthorizedComponent } from './core/components/unauthorized-page/unauthorized-page.component';
import { homepageResolver } from './pages/homepage/homepage.resolver';
import { DettaglioRisorsaComponent } from './pages/dettaglio-risorsa/dettaglio-risorsa.component';
import { dettaglioRisorsaResolver } from './pages/dettaglio-risorsa/dettaglio-risorsa.resolver';
import { RisorsaGuard } from './shared/guard/risorsa.guard';
import { RiepilogoModificheComponent } from './pages/riepilogo-modifiche/riepilogo-modifiche.component';
import { riepilogoModificheResolver } from './pages/riepilogo-modifiche/riepilogo-modifiche.resolver';
import { StoricoDelegheComponent } from './pages/storico-deleghe/storico-deleghe.component';
import { storicoDelegheResolver } from './pages/storico-deleghe/storico-deleghe.resolver';
import { ControllerCentraleGuard } from './shared/guard/controller-centrale.guard';

const RedirectRules: CanActivateChildFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router: Router = inject(Router);
  const appService = inject(AppService);

  const userEnabled: boolean = appService.user.isUtenteAbilitato ?? false;
  const urlRequestHome = state.url == '/homepage';
  const urlRequestUnauthorized = state.url == '/unauthorized';
  const urlRequestErrorPage = state.url == '/error-page';
  const urlRequestDettaglioRisorsa = state.url == '/dettaglio-risorsa';
  const urlRequestRiepilogoModifiche = state.url == '/riepilogo-modifiche';
  const urlRequestStoricoDeleghe = state.url == '/gestione-deleghe';

  if (userEnabled) {
    if (urlRequestErrorPage || urlRequestUnauthorized) {
      return router.createUrlTree(['homepage']);
    }
    if (urlRequestHome || urlRequestDettaglioRisorsa || urlRequestRiepilogoModifiche || urlRequestStoricoDeleghe) {
      return true;
    }
    return router.createUrlTree(['homepage']);
  } else {
    return router.createUrlTree(['unauthorized']);
  }
};

export const routes: Routes = [
  { path: '', redirectTo: '/homepage', pathMatch: 'full' },
  {
    path: '',
    canActivate: [],
    canActivateChild: [MsalGuard, RedirectRules],
    children: [
      {
        path: 'homepage',
        component: HomepageComponent,
        resolve: { data: homepageResolver },
      },
      {
        path: 'dettaglio-risorsa',
        component: DettaglioRisorsaComponent,
        resolve: { data: dettaglioRisorsaResolver },
        canActivate: [RisorsaGuard],
      },
      {
        path: 'riepilogo-modifiche',
        component: RiepilogoModificheComponent,
        resolve: { data: riepilogoModificheResolver },
      },
      {
        path: 'gestione-deleghe',
        component: StoricoDelegheComponent,
        resolve: { data: storicoDelegheResolver },
        canActivate: [ControllerCentraleGuard],
      }
    ]
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
    canActivate: [],
  },
  { path: 'error-page', component: ErrorPageComponent, pathMatch: 'full' },
  { path: '**', pathMatch: 'full', redirectTo: '/error-page' },
];
